module.exports = __webpack_public_path__ + "img/10.c7743c1a.jpg";